export const stylesSelect = {
  control: (provided: any, state: any) => {
    const { menuIsOpen } = state.selectProps;

    return {
      ...provided,
      width: '140px',
      minHeight: '4vh',
      height: '32px',
      border: menuIsOpen ? '' : '1px solid #d9dfea',
      borderRadius: '10px',
      boxShadow: menuIsOpen ? '0 0 0 2px rgba(24, 144, 255, 0.2)' : 'none',
      backgroundColor: '#ffffff',
      paddingLeft: '10px',
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      color: '#2b3858',
      cursor: 'pointer',

      ':hover': {
        borderColor: menuIsOpen ? '' : '#40a9ff',
      },

      '@media (max-width: 520px)': {
        minHeight: '4vh',
      },

      '@media (max-height: 850px)': {
        height: '4vh',
        width: '18vh',
      },
    };
  },

  menu: (provided: any) => {
    return {
      ...provided,
      backgroundColor: '#ffffff',
      borderRadius: '10px',
      boxShadow: '0 8px 10px rgba(208, 214, 232, 0.8)',
      padding: '5px 0',
      zIndex: 999,
    };
  },

  menuList: (provided: any) => {
    return {
      ...provided,
      padding: '0',
      zIndex: 10000,
    };
  },

  option: (provided: any, { isFocused, isSelected }: { isFocused: any; isSelected: any }) => {
    return {
      ...provided,
      cursor: 'pointer',
      backgroundColor: isSelected ? '#e6f7ff' : isFocused ? '#f4f5fa' : '#ffffff',
      color: '#2b3858',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: isSelected ? '500' : 'normal',
      paddingLeft: '10px',
      marginBottom: '1px',

      ':active': {
        backgroundColor: '#f4f5fa',
      },

      '@media (max-height: 850px)': {
        fontSize: '11px',
      },

      '@media (max-height: 550px)': {
        fontSize: '9px',
      },
    };
  },

  input: (styles: any) => ({
    ...styles,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '17px',
    fontWeight: '400',
    color: '#2b3858',

    input: {
      cursor: 'pointer',

      '@media (max-width: 850px)': {
        fontSize: '1.7vh',
        fontWeight: '500',
      },

      '@media (max-height: 850px)': {
        margin: '0',
      },
    },
  }),

  singleValue: (styles: any) => ({
    ...styles,
    width: '100%',
    textOverflow: 'ellipsis',
    position: 'absolute',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '400',
    color: '#2b3858',

    '@media (max-height: 850px)': {
      fontSize: '1.7vh',
      fontWeight: '500',
    },
  }),

  placeholder: (styles: any) => ({
    ...styles,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
    fontSize: '14px',
    lineHeight: '16px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: '#2B3858',
    margin: '0',
  }),

  valueContainer: (styles: any) => ({ ...styles, padding: '0', overflowY: 'auto', maxHeight: '100px' }),

  noOptionsMessage: (styles: any) => ({
    ...styles,
    padding: '5px 0',

    img: {
      width: '60px',
      height: '60px',
    },
  }),

  dropdownIndicator: (styles: any) => {
    let color = '#2b3858';

    return {
      ...styles,
      transition: '0.5s',
      marginRight: '5px',
      padding: '0 5px',

      path: {
        stroke: color,
      },

      img: {
        height: '13px',
        width: '13px',

        '@media (max-height: 850px)': {
          height: '9px',
          width: '9px',
        },
      },
    };
  },
};
